<div class="d-flex u-gap-3x-sm">
  <div [innerHTML]="content" [class.u-line-clamp]="(isCollapsed$ | async) === true"></div>
  <i
    class="ui icon chevron"
    [class.down]="isCollapsed$ | async"
    [class.up]="(isCollapsed$ | async) === false"
    (click)="toggleView()"
  ></i>
</div>
